(ns client-portal.client.voice-insights.items.comparison.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(def root-path [:voice-insights :items :comparison])
(def items-path (conj root-path :items))

(defn item-data-path [index]
  (conj items-path index :data))

(re/reg-event-db
  :vi-items/remove-comparison-item re/middleware
  (fn [db [index]]
    (re/dispatch [:vi-items/set-comparison-items-query-param])
    (update-in db items-path dissoc index)))

(re/reg-auth0-loader
  :vi-items/load-comparison-item-data-by-index
  (fn [[[_ index]]]
    (item-data-path index))
  (fn [db [_ index]]
    (let [item-name (get-in db (conj items-path index :label))]
      (when (and item-name (concepts.d/current-concept-id db))
        {:method :post
         :url "/api/vi/item"
         :json-params (assoc (vi.d/base-query-args db {})
                        :item item-name)})))
  :transf (fn [resp]
            (or (some-> resp
                        :body
                        (util/->kebab-case-keywords))
                {}))
  :error-transf (fn [] {}))

(re/reg-auth0-load-sub
  :vi-items/comparison-item-data-by-index-
  (fn [_ index]
    (item-data-path index))
  :vi-items/load-comparison-item-data-by-index)

(re/reg-sub
  :vi-items/comparison-item-by-index-
  (fn [db [_ index]]
    (get-in db (conj items-path index))))

(re/reg-sub
  :vi-items/all-comparison-items-
  (fn [db]
    (get-in db items-path)))

(re/reg-event-db
  :vi-items/set-comparison-items-query-param re/middleware
  (fn [db]
    (try
      (let [items (some->> (get-in db items-path)
                           (mapv (fn [[index item]]
                                   (when-let [l (:label item)]
                                     [index {:label l}])))
                           (filterv identity)
                           (into {})
                           (util/when-not-empty)
                           (util/map->json-string)
                           (util/base-64-encode))]
        (re/dispatch [:router/go-with-merged-query-params
                      {:comp items}]))
      (catch :default _
        nil))
    db))

(re/reg-event-db
  :vi-items/init-comparison-items re/middleware
  (fn [db]
    (let [comp-val (:comp (router/current-query-params db))
          init-items (try
                       (some->> comp-val
                                (util/base-64-decode)
                                (util/json-string->map-basic)
                                (mapv (fn [[index item]]
                                        [(util/parse-int index) (util/->kebab-case-keywords item)]))
                                (into {}))
                       (catch :default _
                         nil))]
      (when (and comp-val (not init-items))
        (re/dispatch [:router/go-with-merged-query-params
                      {:comp nil}]))
      (assoc-in db items-path init-items))))
